import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { SurveysContext } from "../../../context/users/SurveysContext";
import {
  Box,
  Button,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";

import { FcSurvey, FcCloseUpMode } from "react-icons/fc";

function Survey() {
  const {
    userSurveyList,
    surveyUserAllList,

    svSeqno,
    questList,
    getQuestSubmit,

    answerList,
    getAnswerListSubmit,

    setVote,
    voteSubmit,
  } = useContext(SurveysContext);

  const navigate = useNavigate();

  const handleOptionChange = (mainSeqno, queSeqno, ansSeqno) => {
    const list = {
      sv_main_seqno: mainSeqno,
      sv_question_seqno: queSeqno,
      sv_ans_seqno: ansSeqno,
    };
    setVote((prevVote) => {
      const newVote = prevVote.filter(
        (item) => item.sv_question_seqno !== queSeqno
      );
      return [...newVote, list];
    });
  };

  const handleCancel = () => {
    const confirmed = window.confirm("설문조사를 취소 하시겠습니까?");
    if (confirmed) {
      alert("설문조사가 취소되었습니다.");
      navigate("//");
      window.location.reload();
    }
  };

  // svSeqno 값이 변경될 때마다 질문 목록 조회
  useEffect(() => {
    if (svSeqno !== null) {
      getQuestSubmit(svSeqno);
    }
  }, [svSeqno]);

  useEffect(() => {
    surveyUserAllList();
    getQuestSubmit();
    getAnswerListSubmit();
  }, []);

  return (
    <main className="survey">
      <div className="title">
        <h1>설문조사</h1>
      </div>

      {userSurveyList.map((survey) => (
        <div key={survey.seqno}>
          <h2>
            <FcSurvey style={{ verticalAlign: "text-top" }} />
            &nbsp;
            {survey.sv_title}
          </h2>
          <h3>{survey.sv_content}</h3>
        </div>
      ))}
      <Box sx={{ padding: 2 }}>
        {questList.length > 0 ? (
          questList.map((question) => (
            <Box key={question.seqno} sx={{ marginBottom: 10 }}>
              <FormLabel component="legend">
                <FcCloseUpMode style={{ verticalAlign: "text-top" }} /> &nbsp;
                {question.sv_question_content}
              </FormLabel>
              <RadioGroup
                aria-label={question.sv_question_content}
                name={`question-${question.seqno}`}
                row
                onChange={(e) =>
                  handleOptionChange(
                    question.sv_seqno,
                    question.seqno,
                    parseInt(e.target.value)
                  )
                }
              >
                {answerList
                  .filter(
                    (answer) => answer.sv_question_seqno === question.seqno
                  )
                  .map((answer) => (
                    <FormControlLabel
                      key={answer.seqno}
                      value={answer.seqno}
                      control={<Radio />}
                      label={answer.sv_ans_content}
                    />
                  ))}
              </RadioGroup>
            </Box>
          ))
        ) : (
          <p>데이터를 불러오는 중입니다...</p>
        )}
      </Box>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <Button variant="outlined" sx={{ marginRight: 2 }} onClick={voteSubmit}>
          제출
        </Button>
        <Button variant="outlined" color="error" onClick={handleCancel}>
          취소
        </Button>
      </div>
    </main>
  );
}

export default Survey;
